/* eslint-disable import/first */
import React, { Component } from "react";
import { isEmpty, isString, get, isNil } from "lodash";
import PropTypes from "prop-types";
import { Loading, Message, Button } from "@alifd/next";
import DeviceSdk from "@alife/devicetasksdk";
import request from "@ali/request-olympics";
import { transformUrl } from './adapter/request';
import setRequestParams from "./addons/request/setRequestParams";
import Form from "./components/Form";
import GlobalMessage from "./components/GlobalMessage";
import FormNav from "./components/FormNav";
import ErrorTab from "./components/ErrorTab";
import { NavBar } from "./components/Step";
import SimpleForm from "./form";
import { UnionDetailForm, UnionForm } from "./union-form";

import "@alife/devicetasksdk/lib/index.scss";
import "./index.scss";

export { SimpleForm, UnionForm, UnionDetailForm };

// 注册一些依赖包信息
window.__FORM_RENDER_DEPS__ = __FORM_RENDER_DEPS__ || {};

class ReceptForm extends Component {
  constructor(props) {
    super(props);
    this.formInstance = null;
    this.formLoadingTimer = null;
    this.state = {
      schema: null,
      groups: [],
      errorList: [],
      globalErrorList: [],
      errorListVisible: false,
      loading: true,
      pages: [],
      currentPage: 0,
      PageMode: "normal",
      isEdit: false,
      sdkVisible: false,
      sdkStatus: "",
      formLoading: false, // 用于控制表单区域的loading效果，与loading状态有区别，loading是控制初始化加载渲染状态

      // todo 测试待删
      fieldsSelectModeStatus: false,
      fieldsSelectModeData: [],
    };
    const { params = {} } = props;
    setRequestParams({ mock: params.mock });

    // todo 测试代码，要删掉
    this.getFieldsSelectData = this.getFieldsSelectData.bind(this);

    this.onFieldsSelectChange = this.onFieldsSelectChange.bind(this);

    // todo 测试代码，需要删除
    this.setFieldsSelectData = this.setFieldsSelectData.bind(this);
    this.saveFunc = this.saveFunc.bind(this);
  }

  componentDidMount() {
    const { params, onLoad, renderUrl, headers, detail } = this.props;
    request({
      url: transformUrl(renderUrl),
      method: "GET",
      headers: {
        ...headers,
      },
      data: {
        ...params,
        detail: detail ? 1 : undefined,
        t: Date.now(),
      },
    }).then((response) => {
      let res = (response || {}).data || response || {};
      if (!res.formSchema && response && response.data && response.data.data) {
        res = response.data.data;
      }
      const data = isString(res.formSchema)
        ? JSON.parse(res.formSchema)
        : res.formSchema;
      this.setState({
        loading: false,
        schema: data,
        PageMode: get(data, "pages[0].layout.props.mode", "normal"),
        globalMessage: data.global && data.global.globalMessage,
        isEdit: data.global && data.global.edit,
        disableDevicePlugin: data.global && data.global.disableDevicePlugin,
      });
    });
    if (onLoad) {
      onLoad(this);
    }
    window.saveFunc = this.saveFunc;
  }

  componentWillUnmount() {
    if (this.formInstance && this.formInstance.formContext) {
      this.formInstance.formContext.emitter.removeListener(
        "reportGroups",
        this.groupChangeHandler
      );
      this.formInstance.formContext.emitter.removeListener(
        "pageChange",
        this.pageChangeHandler
      );
      this.formInstance.formContext.emitter.removeListener(
        "errorListChange",
        this.errorListChangeHandler
      );
      this.formInstance.formContext.emitter.removeListener(
        "callDeviceSdk",
        this.callDeviceSdkHandler
      );
    }
    this.formLoadingTimer && clearTimeout(this.formLoadingTimer);
  }

  onFormReady = (instance) => {
    this.formInstance = instance;
    this.formInstance.formContext.emitter.on(
      "pageChange",
      this.pageChangeHandler
    );
    this.formInstance.formContext.emitter.on(
      "reportGroups",
      this.groupChangeHandler
    );
    this.formInstance.formContext.emitter.on(
      "errorListChange",
      this.errorListChangeHandler
    );
    this.formInstance.formContext.emitter.on(
      "callDeviceSdk",
      this.callDeviceSdkHandler
    );
  };

  getErrorPages() {
    const errorFieldIds =
      this.formInstance.formContext.getGlobal("errorFieldIds");
    const errorPage = {};

    if (errorFieldIds) {
      errorFieldIds.forEach((fieldId) => {
        errorPage[this.formInstance.stepManager.getPageById(fieldId)] = true;
      });
    }
    return Object.keys(errorPage);
  }

  pageChangeHandler = (index) => {
    const errorPages = this.getErrorPages();

    this.setState(
      {
        currentPage: index,
        pages: this.formInstance.stepManager.pages.map((item, pageIndex) => {
          return {
            ...item,
            hasError: errorPages.includes(item.id),
            disabled: this.formInstance.stepManager.travel + 1 < pageIndex,
          };
        }),
      },
      () => {
        this.formInstance.fieldApi.turnPages(
          this.state.currentPage,
          this.state.pages.map((item) => item.id)
        );
        this.props.onPageChange &&
          this.props.onPageChange(this.state.currentPage);
      }
    );
  };

  groupChangeHandler = (groups) => {
    if (this.formInstance && this.formInstance.stepManager) {
      const errorFieldIds =
        this.formInstance.formContext.getGlobal("errorFieldIds");
      if (errorFieldIds) {
        const errorPages = this.getErrorPages();

        this.setState(({ pages }) => {
          return {
            pages: pages.map((item) => {
              return {
                ...item,
                hasError: errorPages.includes(item.id),
              };
            }),
          };
        });
      }
    }
    this.setState({ groups });
  };

  errorListChangeHandler = ({ visible, errorList, globalErrorList } = {}) => {
    const result = {};
    !isNil(visible) && Object.assign(result, { errorListVisible: visible });
    !isNil(errorList) && Object.assign(result, { errorList });
    !isNil(globalErrorList) && Object.assign(result, { globalErrorList });
    this.setState(result);
  };

  callDeviceSdkHandler = ({ visible, status } = {}) => {
    const targetState = {};
    visible !== undefined &&
      Object.assign(targetState, { sdkVisible: visible });
    status !== undefined && Object.assign(targetState, { sdkStatus: status });
    this.setState(targetState);
  };

  triggerScrollGroup = (key) => {
    if (this.formInstance) {
      this.formInstance.fieldApi.scrollToGroup(key);
    }
  };

  triggerScrollField = (key) => {
    if (this.formInstance) {
      if (this.formInstance.stepManager) {
        const page = this.formInstance.stepManager.getPageById(key);
        !isNil(page) && this.formInstance.stepManager.goPage(page);
      }
      this.formInstance.fieldApi.scrollToField(key);
    }
  };

  getErrorMsg = (options) => {
    return this.formInstance && this.formInstance.fieldApi.getErrorMsg(options);
  };

  // 用于支持iframe关闭后保存草稿需求
  saveFunc(type) {
    return this.save(type);
  }

  save = (event) => {
    const { submitHandler } = this.props;

    if (!this.formInstance) {
      submitHandler({ success: false, errorMsg: "表单仍在加载中", event });
    }

    const mode = this.state.PageMode;

    if (
      event === "submit" &&
      mode === "step" &&
      this.state.currentPage < this.state.pages.length - 1
    ) {
      return this.savePage()
        .then((res) => {
          submitHandler({
            ...res,
            event,
            mode,
          });
          if (!res || !res.success) {
            return;
          }
          this.formInstance.stepManager.next();
        })
        .catch((res) => {
          if (res.stack) {
            submitHandler({ success: false, errorMsg: res, event, mode });
          } else {
            submitHandler({ ...res, success: false, event, mode });
          }
        });
    }

    let options = {};
    if (event === "submit") {
      options = { actionCode: "FormSubmit" };
    }
    if (event === "saveDraft") {
      options = {
        actionCode: "SaveFormDraft",
        draft: true,
        noValid: true,
      };
    }
    this.formInstance.submitManager
      .save(options)
      .then((res) => {
        submitHandler({ ...res, event, mode });
      })
      .catch((res) => {
        if (res.stack) {
          submitHandler({ ...res, success: false, errorMsg: res, event, mode });
        } else {
          submitHandler({ ...res, success: false, event, mode });
        }
      });
  };

  savePage = () => {
    const fieldIds = this.formInstance.stepManager.getFieldIds();
    return this.formInstance.submitManager.savePage(fieldIds);
  };

  prevPage = () => {
    this.formInstance.stepManager.prev();
  };

  nextPage = () => {
    const mode = this.state.PageMode;

    if (
      mode === "step" &&
      this.state.currentPage < this.state.pages.length - 1
    ) {
      return this.savePage().then((result) => {
        if (!result || !result.success) {
          return;
        }
        this.formInstance.stepManager.next();
      });
    }
  };

  // todo 测试代码，需要删除
  getFieldsSelectData() {
    const data = this.formInstance.formContext.getGlobal() || {};
    console.log("fields data", data);
  }

  // todo 测试代码，需要删除
  setFieldsSelectData() {
    console.log("delete", this.state.fieldsSelectModeData.slice(0, 1));
    this.setState({
      fieldsSelectModeData: this.state.fieldsSelectModeData.slice(0, 1),
    });
  }

  // 表单项选择模式，选中表单项改变的方法
  onFieldsSelectChange(params) {
    // 重新包装props.onFieldsSelectChange，解决hooks对象传方法时的闭包问题
    typeof this.props.onFieldsSelectChange === "function" &&
      this.props.onFieldsSelectChange(params);

    this.setState({ formLoading: true }, () => {
      this.formLoadingTimer = setTimeout(
        () => this.setState({ formLoading: false }),
        100
      );
    });

    // // todo 测试代码，需要删除
    // const { checked, currentData, selectedData } = params;
    // console.log("fields select change", checked, currentData, selectedData);
    // this.setState({
    //   fieldsSelectModeData: [...selectedData],
    // });
  }

  render() {
    const { detail, matters } = this.props;
    const {
      groups,
      schema,
      globalMessage,
      loading,
      isEdit,
      disableDevicePlugin,
      pages,
      currentPage,
      errorListVisible,
      errorList,
      globalErrorList,
      sdkVisible,
      sdkStatus,
    } = this.state;
    if (loading) {
      return <Loading tip="加载中..." style={{ width: "100%", height: 220 }} />;
    }

    // TODO: FormNav 应该和 FormStep 通过策略模式来做，后面有时间再重构
    // <Container type="normal|step"><GlobalMessage/><Form/></Container>
    let mode;
    if (detail) {
      mode = "normal";
    } else {
      mode = this.state.PageMode;
    }
    const shouldShowStep = mode === "step" && pages.length > 1;

    const sdkStyleMap = {
      gpy: { width: "1000px", height: "636px" },
    };

    const sdkProps = {
      ...sdkStyleMap[sdkStatus],
      gpyTotal: "9",
      status: sdkStatus,
      visible: sdkVisible,
      closeDialog: () => {
        this.setState({ sdkVisible: false });
      },
      fail: () => {
        Message.warning("设备连接失败");
      },
      success: (data) => {
        // 调用sdk记录设备调用返回结果
        this.formInstance.formContext.emitter.emit(
          "callDeviceSdkSuccess",
          data
        );
      },
    };

    return (
      <div>
        {/* TODO 待删 */}
        {/* <Button onClick={this.getFieldsSelectData}>获取表单选项数据</Button>
        <Button onClick={this.setFieldsSelectData}>删除选项</Button>
        <Button
          onClick={() =>
            this.setState({
              fieldsSelectModeStatus: !this.state.fieldsSelectModeStatus,
              fieldsSelectModeData: this.state.fieldsSelectModeData,
            })
          }
        >
          切换选择模式
        </Button> */}
        {/* 分组模式 */}
        {mode === "normal" && !detail && (
          <FormNav groups={groups} triggerScroll={this.triggerScrollGroup} />
        )}
        {/* 分步模式 */}
        {mode === "step" && shouldShowStep && (
          <NavBar
            dataSource={pages}
            currentStep={currentPage}
            onClick={(index) => {
              if (index <= this.state.currentPage) {
                this.formInstance.stepManager.go(index);
              } else {
                this.savePage().then((result) => {
                  if (!result || !result.success) {
                    return;
                  }
                  this.formInstance.stepManager.go(index);
                });
              }
            }}
          />
        )}
        {globalMessage && <GlobalMessage message={globalMessage} />}
        <ErrorTab
          visible={errorListVisible}
          errorList={errorList}
          globalErrorList={globalErrorList}
          triggerScroll={this.triggerScrollField}
        />
        {schema && (
          <Loading visible={this.state.formLoading} inline={false}>
            <Form
              {...this.props}
              formOptions={this.props.formOptions || {}}
              // // todo 待优化
              // formOptions={{
              //   fieldsSelectModeStatus: this.state.fieldsSelectModeStatus,
              //   fieldsSelectModeData: this.state.fieldsSelectModeData,
              // }}
              onFieldsSelectChange={this.onFieldsSelectChange}
              isEdit={isEdit}
              disableDevicePlugin={disableDevicePlugin}
              schema={schema}
              initErrorMsg={this.props.initErrorMsg || mode === "step"}
              onFormReady={this.onFormReady}
            />
          </Loading>
        )}
        <DeviceSdk originProps={sdkProps} only="true" />
      </div>
    );
  }
}

ReceptForm.defaultProps = {
  detail: false,
  initErrorMsg: false,
  endpoint: "online",
  renderUrl: "/form/formrender",
  submitUrl: "/api/reception/execute",
  params: {},
  formOptions: {},
};

ReceptForm.propTypes = {
  detail: PropTypes.bool,
  initErrorMsg: PropTypes.bool,
  endpoint: PropTypes.string,
  renderUrl: PropTypes.string,
  submitUrl: PropTypes.string,
  getResourceUrl: PropTypes.string,
  params: PropTypes.object,
  formOptions: PropTypes.object, // 表单配置参数
  onFieldsSelectChange: PropTypes.func, // 表单项选择模式，选择选项是的回调
};

export default ReceptForm;
